import script from "./dynamic-config.vue?vue&type=script&setup=true&lang=js"
export * from "./dynamic-config.vue?vue&type=script&setup=true&lang=js"

import "./dynamic-config.scss?vue&type=style&index=0&id=49f62054&lang=scss&scoped=true"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49f62054"]])

export default __exports__